import React, { useState, forwardRef, useImperativeHandle } from 'react';


const SalaryContract = forwardRef((props, ref) => {
     // Add validation support
     const [validationErrors, setValidationErrors] = useState({});

     useImperativeHandle(ref, () => ({
          validateForm: () => {
               return true; // For now, always return true
          },
          clearValidation: () => {
               setValidationErrors({});
          }
     }));

     const [localFormData, localSetFormData] = useState({
          ctc: '',
          latest_agreement_valid_date: '',
          latest_agreement_end_date: '',
          latest_contract_fee_revision_amount: '',
     });
     const formData = props.formData !== undefined ? props.formData : localFormData;
     const setFormData = props.setFormData !== undefined ? props.setFormData : localSetFormData;

     return (
          <div className="custom_form_wrapper">
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="ctc"
                              id="ctc"
                              placeholder="CTC"
                              value={formData.ctc}
                              onChange={e => setFormData({ ...formData, ctc: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="ctc">CTC</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="latest_agreement_valid_date"
                              id="latest_agreement_valid_date"
                              placeholder="YYYY-MM-DD"
                              value={formData.latest_agreement_valid_date || ''}
                              onChange={e => setFormData({ ...formData, latest_agreement_valid_date: e.target.value })}
                              onFocus={e => e.target.type = 'date'}
                              onBlur={e => { if (!e.target.value) e.target.type = 'text'; }}
                              max={new Date().toISOString().split('T')[0]}
                              autoComplete="off"
                         />
                         <label htmlFor="latest_agreement_valid_date">Latest Agreement Valid Date</label>
                    </div>
                    <div className="row align-items-center mb-3">
                         <div className="col-auto">
                              <label style={{ fontSize: '14px', marginLeft: '5px' }} htmlFor="latest_agreement_end_date" className="form-label mb-0">Latest Agreement End Date</label>
                         </div>
                         <div className="col">
                              <input
                                   type="date"
                                   className="form-control form-control-sm"
                                   name="latest_agreement_end_date"
                                   id="latest_agreement_end_date"
                                   value={formData.latest_agreement_end_date || ''}
                                   onChange={e => setFormData({ ...formData, latest_agreement_end_date: e.target.value })}
                                   max={new Date().toISOString().split('T')[0]}
                                   autoComplete="off"
                              />
                         </div>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="latest_contract_fee_revision_amount"
                              id="latest_contract_fee_revision_amount"
                              placeholder="Amount"
                              value={formData.latest_contract_fee_revision_amount}
                              onChange={e => setFormData({ ...formData, latest_contract_fee_revision_amount: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="latest_contract_fee_revision_amount">Latest Contract Fee Revision Amount</label>
                    </div>
               </div>
          </div>
     );
});

export default SalaryContract;